import {ApiRegistryRepository} from 'vue3-starter/src/typescript/api-registry/ApiRegistryRepository';
import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';
import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {USER_CONNECTED} from 'malt-webmvc-common/src/main/js/events/signin';
import {applicationConfig} from './applicationConfig';
import {Store} from 'vuex';
import {StoreState} from '@/brief-hub/store/state/StoreState';
import {MutationsType} from '@/brief-hub/store/modules/connected-user/mutations';
import userService from '@/brief-hub/user/UserService';
import UserResource from '@/brief-hub/user/UserResource';

export const filtersSessionStorageId = 'brief-filters-v2';
// WARN: identityId is used for the immersion mode
export const identityIdFilterParam = 'identityIds';

async function storeRegistry() {
    const apiRegistryRepository = new ApiRegistryRepository();
    const [registry, registryErr] = await apiRegistryRepository.get();
    if (registryErr || !registry) {
        throw new Error('Impossible to get/set application api registry: ' + registryErr);
    }

    context.registry = registry;
}

export async function setUpAppContext(store: Store<StoreState>): Promise<void> {
    context.registryApi = applicationConfig.apiRegistryUrl;

    await storeRegistry();

    async function updateUser(): Promise<HttpServiceResponse<UserResource>> {
        const [userData, userDataErr] = await userService.get();
        if (userData && !userDataErr) {
            await store.commit(MutationsType.UPDATE_CONNECTED_USER, userData);
        }
        return [userData, userDataErr];
    }

    const [, userDataErr] = await updateUser();

    if ([401, 403].includes(userDataErr?.response?.status || 0)) {
        Hop.events.on(USER_CONNECTED, async () => {
            const [user] = await updateUser();
            if (!user) {
                // if the user log-in while in the funnel, let's reload the page
                // to have a chance to automatically select a client identity.
                // Otherwise, if they only have a freelancer identity they will be considered
                // anonymous and a client signup will be started on the brief submit
                window.location.reload();
            } else {
                // let's update the registry to have access to links depending on the connected user
                await storeRegistry();
            }
        });
        return;
    } else if (userDataErr) {
        throw userDataErr;
    }

    const queryString = new URLSearchParams(window.location.search);

    let filters = queryString.getAll(identityIdFilterParam);
    if (!filters.length) {
        const storedFilters = sessionStorage.getItem(filtersSessionStorageId);
        if (storedFilters) {
            filters = JSON.parse(storedFilters);
        }
    }
    await store.commit(MutationsType.UPDATE_SEARCHED_IDENTITIES, filters);
}
